import React from 'react';

import NavigationMenuSection from "../../../menu-items/section/section";
import ReorderList from "../../../../../core/gd-ui/sortable-list-4/reorder-list";
import NavigationSection from "../../../../../core/model2/navigation/navigation-section";
import {ViewType} from "../../../../../core/gd/const/views/view-type";
import MainMenu_ItemMyWork from "./home/my-work";
import MainMenu_ItemNotifications from "./home/notifications";
import NavigationMenuItemPersonalView from "./personal-view";
import PersonalView from "../../../../../core/model2/view/personal-view/personal-view";
import NavigationMenu_PersonalViewsMore from "./btn-more";
import NavigationMenu_HomeLocalSettings from "../local-settings"
import MainMenu_ItemMyTasks from "./home/my-tasks"

type Props = {
    navigationSection   : NavigationSection
    localSettings       : NavigationMenu_HomeLocalSettings
}

// const debug = "NavigationMenu_PersonalViews"
const debug = false

export default class NavigationMenu_PersonalViews extends React.Component<Props> {

    constructor(props:any) {
        super(props)
    }

    componentDidMount() {
        gd.bus.subscribe('gd.session.customViews:change', this, this.update)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    update = () => {
        this.forceUpdate()
    }

    onDragMyWorkItemsEnd = (items:PersonalView[]) => {

        debug && console.log(debug, "OnDragMyWorkItemsEnd", items)

        const sortPositions = _.map(items, item=>item.id);

        debug && console.log(debug, "sortPositions=", sortPositions)

        gd.user.menu.myWork.sortPositions = sortPositions
        gd.user.menu.save();

    }

    render() {

        const homeViews = gd.user.personalViews.homeViews

        const items = _.map(homeViews, (view:PersonalView) => {

            switch (view.type) {

                case ViewType.MY_WORK:
                    return {
                        item        : view,
                        component   : <MainMenu_ItemMyWork key                  = "my-work"
                                                           navigationSection    = {this.props.navigationSection}/>
                    }

                case ViewType.NOTIFICATIONS:
                    return {
                        item        : view,
                        component   : <MainMenu_ItemNotifications key               = "notifications"
                                                                  navigationSection = {this.props.navigationSection} />
                    }

                case ViewType.MY_TASKS_LIST:
                    return {
                        item        : view,
                        component   : <MainMenu_ItemMyTasks key                 = "my-tasks"
                                                            view                = {view}
                                                            navigationSection   = {this.props.navigationSection}
                                                            localSettings       = {this.props.localSettings}/>
                    }

                default:
                    return {
                        item: view,
                        component:  <NavigationMenuItemPersonalView view                = {view}
                                                                    navigationSection   = {this.props.navigationSection}/>
                    }
            }

        })

        return (
            <NavigationMenuSection collapsible={false}>
                <ReorderList items={items} keyFunction={(item:PersonalView)=>item.id} onReorder={this.onDragMyWorkItemsEnd}/>
                {gd.user.personalViews.hasMoreViews &&
                    <NavigationMenu_PersonalViewsMore/>}
            </NavigationMenuSection>
        )
    }
}
